import styled from 'styled-components';

export const Header = styled.header`
  padding-top: 8px;
  @media (min-width: 768px) {
    padding-top: 16px;
  }

  @media (min-width: 1440px) {
    padding-top: 12px;
  }
`;
